/* ss-video-reviews — click-to-play testimonial videos.
   Clicking a video tile toggles playback (with sound, user-initiated).
   Only one plays at a time; the play button + text overlay hide while playing. */
(function () {
  'use strict';

  function mediaWraps() {
    return document.querySelectorAll('.ss-vreviews__media-wrap');
  }

  function pauseAllExcept(current) {
    mediaWraps().forEach(function (wrap) {
      var v = wrap.querySelector('.ss-vreviews__video');
      if (v && v !== current) {
        v.pause();
        wrap.classList.remove('is-playing');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('.ss-vreviews__media-wrap');
    if (!wrap) return;

    var video = wrap.querySelector('.ss-vreviews__video');
    if (!video) return; // image-only tile

    e.preventDefault();

    if (video.paused) {
      pauseAllExcept(video);
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(function () {
          wrap.classList.add('is-playing');
        }).catch(function () {
          /* autoplay/codec restriction — leave overlay visible */
        });
      } else {
        wrap.classList.add('is-playing');
      }
    } else {
      video.pause();
      wrap.classList.remove('is-playing');
    }
  });

  // Keep state in sync if a video pauses for any other reason.
  document.addEventListener('pause', function (e) {
    var video = e.target;
    if (video.classList && video.classList.contains('ss-vreviews__video')) {
      var wrap = video.closest('.ss-vreviews__media-wrap');
      if (wrap) wrap.classList.remove('is-playing');
    }
  }, true);
})();
